import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';
import { SuggestBox } from '../SuggestBox';
import defaults from '../translations/en.json';
const FieldHeader = styled.div.withConfig({
  displayName: "FaxConfirmContent__FieldHeader",
  componentId: "xqy8yq-0"
})(["margin-top:10px;"]);
export const FaxConfirmContent = ({
  siteFaxList,
  setFaxOption,
  faxOption
}) => {
  var _faxOption$referenceT, _faxOption$subjectTex, _faxOption$noteText;

  const list = siteFaxList ? siteFaxList.map(siteFax => _objectSpread({
    label: siteFax.recipientname
  }, siteFax)) : [];

  const handleNoteChange = event => {
    const {
      value: nextValue
    } = event.target;
    setFaxOption(_objectSpread(_objectSpread({}, faxOption), {}, {
      noteText: nextValue
    }));
  };

  const handleSubjectChange = event => {
    const {
      value: nextValue
    } = event.target;
    setFaxOption(_objectSpread(_objectSpread({}, faxOption), {}, {
      subjectText: nextValue
    }));
  };

  const handleReferenceChange = event => {
    const {
      value: nextValue
    } = event.target;
    setFaxOption(_objectSpread(_objectSpread({}, faxOption), {}, {
      referenceText: nextValue
    }));
  };

  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, defaults.selectFax), /*#__PURE__*/React.createElement(SuggestBox, {
    inputId: "fax-select",
    editablePlaceholder: true,
    placeholder: "",
    options: list,
    onChange: option => setFaxOption(option || null),
    value: faxOption,
    menuPlacement: "bottom"
  }), /*#__PURE__*/React.createElement(React.Fragment, null, defaults.faxNumber, ":", faxOption && ` ${faxOption.recipientnumber}` || ''), /*#__PURE__*/React.createElement(FieldHeader, null, defaults.reference, ":"), /*#__PURE__*/React.createElement(TextField, {
    id: "fax-reference",
    name: "editableFaxReference",
    placeholder: "",
    minRows: 2,
    maxRows: 90,
    onChange: handleReferenceChange,
    value: (_faxOption$referenceT = faxOption === null || faxOption === void 0 ? void 0 : faxOption.referenceText) !== null && _faxOption$referenceT !== void 0 ? _faxOption$referenceT : '',
    variant: "outlined",
    multiline: true,
    disabled: !faxOption
  }), /*#__PURE__*/React.createElement(FieldHeader, null, defaults.faxSubject, ":"), /*#__PURE__*/React.createElement(TextField, {
    id: "fax-subject",
    name: "editableFaxSubject",
    placeholder: "",
    minRows: 2,
    maxRows: 90,
    onChange: handleSubjectChange,
    value: (_faxOption$subjectTex = faxOption === null || faxOption === void 0 ? void 0 : faxOption.subjectText) !== null && _faxOption$subjectTex !== void 0 ? _faxOption$subjectTex : '',
    variant: "outlined",
    multiline: true,
    disabled: !faxOption
  }), /*#__PURE__*/React.createElement(FieldHeader, null, defaults.faxNote, ":"), /*#__PURE__*/React.createElement(TextField, {
    id: "fax-note",
    name: "editableFaxNote",
    placeholder: "",
    minRows: 2,
    maxRows: 90,
    onChange: handleNoteChange,
    value: (_faxOption$noteText = faxOption === null || faxOption === void 0 ? void 0 : faxOption.noteText) !== null && _faxOption$noteText !== void 0 ? _faxOption$noteText : '',
    variant: "outlined",
    multiline: true,
    disabled: !faxOption
  }));
};